import { microApi } from 'app/services/api';
import { ListResponse } from 'app/types';
import qs from 'qs';
import pick from 'lodash/pick';

export const staticApi = microApi.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query<
      {
        data: Array<any>;
        pagination: {
          page: number;
          pageSize: number;
          pages: number;
          total: number;
        };
      },
      {
        current: number;
        pageSize: number;
        searchBy?: string;
        keywords?: string;
      }
    >({
      query: (params) => {
        const queryString = qs.stringify(
          {
            page: params.current,
            pageSize: params.pageSize,
            ...pick(params, ['searchBy', 'keywords'])
          },
          {
            encodeValuesOnly: false,
            indices: false
          }
        );
        return {
          url: `/product-categories${queryString ? '?' + queryString : ''}`,
          method: 'GET'
        };
      },
      transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
        return {
          pagination: baseQueryReturnValue.data.pagination,
          data: baseQueryReturnValue.data.list
        };
      }
    })
  })
});

export const { useLazyGetCategoriesQuery } = staticApi;